<template>
  <div>
    <p>
      <a class="btn btn-outline-info" data-toggle="collapse" href="#collapseExample" role="button"
         aria-expanded="false" aria-controls="collapseExample">
        Шаблоны
      </a>
    </p>
    <div class="collapse" id="collapseExample">
      <ol class="pl-3">
        <li v-for="(blank, index) in blanks">
          <a href="#" @click.prevent="setBlank(blank)">{{blank}}</a>
          [<a href="#" @click.prevent="removeBlank(index)">X</a>]
        </li>
      </ol>
    </div>
    <form @submit.prevent="createIns">
      <div class="d-flex flex-wrap align-content-end">
        <div class="form-group mr-3">
          <div>
            <label>Дата</label>
          </div>
          <date-picker class="w-100" v-model="form.CreateDate" valueType="format"
                       :input-attr="{required: true}"
                       input-class="form-control"
                       :first-day-of-week="1" lang="ru">
          </date-picker>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Тип</label>
          </div>
          <select v-model="form.InsType" class="form-control" required="">
            <option v-for="(item, t) in InsTypes" :key="t" :value="t">{{item}}</option>
          </select>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Группа</label>
          </div>
          <v-select
            v-model="form.ExpenseGroupId"
            :options="ExpenseGroups"
            :taggable="true"
            label="Name"
            :reduce="item => item.Id"
            style="min-width: 200px"
          >
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!form.ExpenseGroupId"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Вид</label>
          </div>
          <v-select
            v-model="form.ExpenseTypeId"
            :options="ExpenseTypes"
            :taggable="true"
            label="Name"
            :reduce="item => item.Id"
            style="min-width: 200px"
          >
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!form.ExpenseTypeId"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Источник</label>
          </div>
          <v-select
            v-model="form.PanelUserId"
            :options="PanelUsers"
            :getOptionLabel="getOptionLabel"
            :reduce="item => item.Id"
            style="min-width: 300px"
          >
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!form.PanelUserId"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Счет</label>
          </div>
          <select
            v-model="form.PaymentTypeId"
            class="form-control"
            required="true"
          >
            <option v-for="paymentType in $root.paymentTypes" :value="paymentType.Id">
              {{paymentType.Name}}
            </option>
          </select>
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Сумма</label>
          </div>
          <input type="number" class="form-control" v-model="form.Amount" style="max-width: 100px" :readonly="!form.PanelUserId">
        </div>
        <div class="form-group mr-3">
          <div>
            <label>Примечание</label>
          </div>
          <input type="text" class="form-control" v-model="form.Description">
        </div>
        <div class="form-group mr-3 d-flex">
          <button type="submit" class="btn btn-outline-success mt-auto">Внести</button>
          <button type="button" class="btn btn-outline-success mt-auto ml-3" @click="saveBlank">
            Сохранить шаблон
          </button>
          <button type="button" class="btn btn-outline-secondary mt-auto ml-3" @click="reset">
            Сбросить
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import _ from 'lodash';
import { get, post } from '@/admin/services/api/http-utils';

const defaultDate = moment().subtract(10, 'd').format('YYYY-MM-DD');

const masterIns = {
  CreateDate: defaultDate,
  InsType: 'out',
  ExpenseGroupId: null,
  ExpenseTypeId: null,
  PaymentTypeId: null,
  Amount: 0,
  PanelUserId: null,
  Description: null,
};
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      form: Object.assign({}, { ...masterIns }),
      InsTypes: {
        in: 'Приход',
        out: 'Расход',
      },
      ExpenseGroups: [],
      ExpenseTypes: [],
      PanelUsers: [],
      blanks: [],
    };
  },
  async mounted() {
    await this.fetchGroups();
    await this.fetchExpenseTypes();
    await this.fetchPanelUsers();
    this.fetchBlanks();

    // this.form.InsType = 'out';
  },
  methods: {
    fetchBlanks() {
      this.blanks = JSON.parse(localStorage.getItem('sferaBlanks'));
    },
    async createIns() {
      await post(`${process.env.VUE_APP_API_HOST}admin/flow`, { data: this.form });
      this.$emit('create-ins');
    },
    async fetchGroups() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/groups`);
      this.ExpenseGroups = data;
    },
    async fetchExpenseTypes() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/expense-types`);
      this.ExpenseTypes = data;
    },
    async fetchPanelUsers() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/flow/panel-users`);
      this.PanelUsers = data;
    },
    // async createGroup(newOption) {
    //   console.log(newOption);
    //   const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/flow/create-group`, { name: newOption });
    //   await this.fetchGroups();
    //   this.form.ExpenseGroupId = data;
    // },
    // async createType(newOption) {
    //   console.log(newOption);
    //   const { data } = await post(`${process.env.VUE_APP_API_HOST}admin/flow/create-type`, { name: newOption });
    //   await this.fetchExpenseTypes();
    //   this.form.ExpenseTypeId = data.Id;
    // },
    getOptionLabel(option) {
      return `${option.Fname && option.Fname !== '_' ? option.Fname : ''} ${option.Lname && option.Lname !== '_' ? option.Lname : ''}`;
    },
    reset() {
      this.form = { ...masterIns };
    },
    saveBlank() {
      const arr = JSON.parse(localStorage.getItem('sferaBlanks')) || [];
      arr.push(this.form);
      localStorage.setItem('sferaBlanks', JSON.stringify(arr));
      this.fetchBlanks();
    },
    setBlank(blank) {
      this.form = Object.assign({}, { ...blank });
    },
    removeBlank(index) {
      let arr = JSON.parse(localStorage.getItem('sferaBlanks')) || [];
      delete arr[index];
      arr = _.filter(arr);
      localStorage.setItem('sferaBlanks', JSON.stringify(arr));
      this.fetchBlanks();
    },
  },
};
</script>
